import { render, staticRenderFns } from "./VesselInsertData.vue?vue&type=template&id=020ebd66&scoped=true&"
import script from "./VesselInsertData.vue?vue&type=script&lang=js&"
export * from "./VesselInsertData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020ebd66",
  null
  
)

export default component.exports